module.exports = __webpack_public_path__ + "img/2dd7a2d09fa94bf8b5c52e5318868b4df.69c8d31a.jpg";